import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import {
  OrganizationSelect,
  ReactFormInput,
  ReactFormSwitch, UserPermissionSelect,
} from '../../../components';
import { Project } from '../../../types/items';
import { selectCurrentUser } from '../../../store/modules/users/selectors';

type Props = {
  clone: Project | null;
};

const DuplicateForm = ({ clone }: Props) => {
  const visibilityId = clone?.visibility_id;
  const { watch } = useFormContext();
  const organizationId = watch('organization_id');
  const { data: user } = useSelector(selectCurrentUser);
  const userFirstCallFilters = useMemo(() => [{ key: 'user_id', value: user?.id || -1 }], [user]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ReactFormInput name="title" label="New Project Name" autoFocus />
      </Grid>
      <Grid item xs={6}>
        <OrganizationSelect
          name="organization_id"
          label="Organization"
          formType="react"
        />
      </Grid>
      <Grid item xs={6}>
        <UserPermissionSelect
          label="Owner"
          name="user_owner_id"
          disableClearable
          disabled={organizationId < 1}
          formType="react"
          firstCallFilters={userFirstCallFilters}
          filters={organizationId > 0 ? [{ key: 'organization_id', value: organizationId }] : []}
          dependentFieldName="organization_id"
          selectFirstOption
        />
      </Grid>

      {
        visibilityId !== 2
        && (
          <Grid item xs={12}>
            <div>
              <ReactFormSwitch name="copy_scripts" label="Copy scripts" />
            </div>
            <div>
              <ReactFormSwitch name="copy_scene_attachments" label="Copy 'locked' media" />
            </div>
          </Grid>
        )
      }

      {
        visibilityId === 2
        && (
          <Grid item xs={12}>
            <p>Please note: media cannot be duplicated for this project</p>
          </Grid>
        )
      }
    </Grid>
  );
};

export default DuplicateForm;
